hmi.utils.insert_module({
    name: 'line_valve',
    instance: null,
    groupType: hmi.constant.groupType.component,
    type: hmi.constant.LINE_VALVE,
    pipe: true,
    svgName: 'line-valve',
});

hmi.utils.load_svg_symbol('assets/images/hmiCommponents/line-valve.svg', hmi.symbols, 'line_valve');

hmi.models.line_valve = function () {
    "use strict";

    //============================================================
    // Public Variables with Default Settings
    //------------------------------------------------------------
    var showMode = hmi.constant.showMode.monitor,
        signal = hmi.constant.signals.not_monitored,
        availableWidth,
        availableHeight,
        zoomTrans,
        valueFormat = d3.format(',.3f'),
        connection_box = hmi.utils.connection_box()
            .left(true)
            .rigth(true),
        resize_component = hmi.utils.resize_component()
            .heightComponent(50)
            .widthComponent(50)
            .widthMaxComponent(500)
            .heightMaxComponent(500)
            .dragCallBack(resizeDragCallback),
        action_component = hmi.utils.action_execute(),
        connections = hmi.utils.connections()
            .conect_type(hmi.constant.conection_types.double)
            .position_connection(hmi.constant.pipeCPosition.B);


    //============================================================
    // Private Variables
    //------------------------------------------------------------


    var allData = [],
        type = hmi.constant.LINE_VALVE,
        groupType = hmi.constant.groupType.component,
        subComponent = {
            main: 0,
            alias: 1
        },
        pipe,
        pendingPipe,
        selectTargetId,
        isInitialize = false,
        dragBehavior,
        dragTarget,
        dispatch = d3.dispatch('componentChange', 'selectElement'),
        svgNode,
        color = {
            normal: '#00a000',
            normalBorder: '#00f000',
            select: '#0000a0',
            warning: '#a0a000',
            warningBorder: '#f0f000',
            alarm: '#a00000',
            alarmBorder: '#f00000'
        },
        defaultWidth = 75,
        defaultHeight = 75,
        xScale = d3.scale.quantize(),
        yScale = d3.scale.quantize();


    var initialize = function () {
        isInitialize = true;

        //create behaviors
        dragBehavior = d3.behavior.drag()
            .on('dragstart', function (d, i) {
                d3.event.sourceEvent.stopPropagation();
                if (dragTarget && showMode === hmi.constant.showMode.design) {
                    dragTarget.parentNode.appendChild(dragTarget);
                    d3.select(dragTarget).attr("pointer-events", "none");
                }
            })
            .on('drag', function (d, i) {
                if (dragTarget && showMode === hmi.constant.showMode.design) {
                    var eventX = d3.event.x - defaultWidth / 2;
                    var eventY = d3.event.y - defaultHeight / 2;

                    var component = null;
                    var componentIndex = allData.findIndex(function (element) {
                        return element.id === selectTargetId;
                    });
                    if (componentIndex !== -1) {
                        component = allData[componentIndex];
                        component.x = eventX;
                        component.y = eventY;
                    }

                    updateComponentPosition(component);
                    transformComponentPosition(this, component);
                }
            })
            .on('dragend', function (d, i) {
                if (dragTarget && showMode === hmi.constant.showMode.design) {
                    var component = null;
                    var componentIndex = allData.findIndex(function (element) {
                        return element.id === selectTargetId;
                    });
                    if (componentIndex !== -1) {
                        component = allData[componentIndex];
                        component.x = xScale(component.x + defaultWidth / 2);
                        component.y = yScale(component.y + defaultHeight / 2);
                        updateComponentPosition(component);
                        transformComponentPosition(this, component);
                    }

                    unSelectComponent();

                    if (component) {
                        dispatch.componentChange({
                            component: component
                        });

                        var linkItem = {
                            linkId: component.id,
                            x: component.x,
                            y: component.y,
                            width: d.width,
                            height: d.height,
                            positionPipe: d.positionPipe,
                        };
                        pipe.updateChangeLink(linkItem);
                    }

                    dragTarget = null;
                    selectTargetId = null;
                }
            });
    };

    var addSubComponents = function (d, data) {
        d.components.push(addMainComponent(d, data));
    };

    var addMainComponent = function (d, data) {
        var result = null;
        if (!data) {
            result = {
                id: d.id + '-sub-' + (subComponent.main + 1),
                key: d.id + '-sub-' + (subComponent.main + 1),
                index: subComponent.main,
                width: defaultWidth,
                height: defaultHeight,
                x: 0,
                y: 0,
            };
        } else {
            result = {
                id: data.components[subComponent.main].id,
                key: data.components[subComponent.main].key,
                index: data.components[subComponent.main].index,
                width: data.components[subComponent.main].width,
                height: data.components[subComponent.main].height,
                x: data.components[subComponent.main].x,
                y: data.components[subComponent.main].y,
            };
        }

        return result;
    };

    var selectComponent = function () {
        d3.select(dragTarget)
            .style('stroke', color.select);
    };

    var unSelectComponent = function () {
        d3.select(dragTarget).attr("pointer-events", "all")
            .style('stroke', null);
        dragTarget = null;
        selectTargetId = null;
        resize_component.clean();
        connection_box.clean();
    };

    var updateComponentPosition = function (d) {
        d.components[subComponent.main].x = d.x;
        d.components[subComponent.main].y = d.y;
        allData[d.index] = d;
    };

    var transformComponentPosition = function (componentTarget, component) {
        var parentTargetId = d3.select(componentTarget).attr('parent');
        d3.select(componentTarget)
            .attr('transform', function (d) {
                return 'translate(' + 0 + ',' + 0 + ')';
            });
        d3.select(componentTarget)
            .attr('transform', function (d) {
                return 'translate(' + component.x + ',' + component.y + ')';
            })
            .attr('x', function (d) {
                return component.x;
            })
            .attr('y', function (d) {
                return component.y;
            });
        switch (showMode) {
            case hmi.constant.showMode.design:

                break;
            case hmi.constant.showMode.monitor:

                break;
        }
    };

    var transformComponentValue = function (d) {

    };

    var initializeCanvasObjects = function (gComponent) {

        //add main component
        var path = gComponent
            .append('g')
            .attr('class', 'line-valve-comp')
            .classed('component-ele', true)
            .attr('id', function (d) {
                return d.components[subComponent.main].id;
            }).attr('parent', function (d) {
                return d.id;
            });

        path.html(svgNode)
            .attr('x', function (d) {
                return d.components[subComponent.main].x;
            })
            .attr('y', function (d) {
                return d.components[subComponent.main].y;
            });

        //main component click diferents behaviours per show mode
        path.on('click', function (event) {
            d3.event.stopPropagation();
            hmi.utils.unSelectComponent();
            event.select = true;
            resize_component.data(event).selector(this);
            selectTargetId = d3.select(this).attr('parent');
            switch (showMode) {
                // click in design mode
                case hmi.constant.showMode.design:
                    dragTarget = this;

                    selectComponent();
                    dispatch.selectElement({
                        component: selectTargetId
                    });
                    break;
                case hmi.constant.showMode.match:
                    dispatch.selectElement({
                        component: selectTargetId,
                        signal: signal,
                        has_pipe: true
                    });
                    dragTarget = this;
                    selectComponent();

                    break;
            }
        });

        path.on({
            'mouseover': function (d) {
                d3.select(this).style('cursor', d.select ? 'move' : 'pointer');
                connection_box.selector(this).data(d).hidden(pendingPipe ? false : true);
            },
            'mouseout': function (d) {
                d3.select(this).style('cursor', 'default');
            }
        });
    };

    function line_valve(selection) {
        selection.each(function (data) {
            allData = data;
            var container = d3.select(this).data(data);
            svgNode = hmi.symbols.line_valve;

            line_valve.container = this;
            if (!isInitialize) {
                initialize();
            }

            container.selectAll('g.nv-group-line_valve')
                .data([data])
                .enter()
                .append('g')
                .attr('class', 'nv-group-line_valve');
            var gEnter = d3.select('g.nv-group-line_valve')
                .selectAll('g.nv-line_valve')
                .data(data, function (item) {
                    return item.key;
                });
            var gComponent = gEnter.enter()
                .append('g')
                .attr('class', 'nv-line_valve')
                .attr('id', function (d) {
                    if (d.components[subComponent.main].x === 0) {
                        updateComponentPosition(d);
                    }
                    return d.id;
                })
                .call(hmi.dragBehavior.dragComponent);
            gEnter
                .attr('x', function (d) {
                    return d.x;
                })
                .attr('y', function (d) {
                    return d.y;
                })
                .attr('transform', function (d) {
                    return 'translate(' + d.components[subComponent.main].x + ',' +
                        d.components[subComponent.main].y + ')';
                });
            initializeCanvasObjects(gComponent);
            action_component(gEnter, gComponent);
            connections(gEnter, gComponent);

            gEnter.select('g.component-ele > svg')
                .attr('width', function (d) {
                    return d.width;
                })
                .attr('height', function (d) {
                    return d.height;
                });

            gEnter.exit().remove();
            line_valve.update = function () {
                container.datum(allData).call(line_valve);
            };

        });

        return line_valve;
    }

    function resizeDragCallback(d) {
        d.components[subComponent.main].x = d.x;
        d.components[subComponent.main].y = d.y;
        d.components[subComponent.main].width = d.width;
        d.components[subComponent.main].height = d.height;
        line_valve.update();
    }

    line_valve.dispatch = dispatch;

    line_valve.options = hmi.utils.optionsFunc.bind(line_valve);

    line_valve._calls = new function () {
        this.getObject = function (data) {
            var idNumber = 1;
            var temp = allData[allData.length - 1];
            if (temp) {
                idNumber = parseInt(temp.id.match(/\d+/g)[0]) + 1;
            }
            var result = null;
            if (!data) {
                result = {
                    id: 'line_valve-' + (idNumber),
                    key: 'line_valve-' + (idNumber),
                    alias: 'line_valve-' + (idNumber),
                    index: allData.length,
                    groupType: groupType,
                    type: type,
                    width: defaultWidth,
                    height: defaultHeight,
                    alignment: hmi.constant.alignment.horizontal,
                    x: 0,
                    y: 0,
                    components: [],
                    config: {
                        pipeColor: 'none'
                    },
                    data: {
                        value: false
                    }
                };
                addSubComponents(result, null);
            } else {
                result = {
                    id: data.id,
                    key: data.key,
                    index: data.index,
                    groupType: groupType,
                    type: data.type,
                    width: data.width,
                    height: data.height,
                    x: data.x,
                    y: data.y,
                    alignment: data.alignment,
                    components: [],
                    config: data.config,
                    data: {
                        value: false
                    }
                };
                addSubComponents(result, data);
            }

            return result;
        };
        this.updateConfig = function (data) {
            var item = allData.find(function (item) {
                return item.key === data.key;
            });
            if (item) {
                item.config = item.config || {};
                item.config.pipeColor = (data.config && data.config.pipeColor) ? data.config.pipeColor : (item.config && item.config.pipeColor) ? item.config.pipeColor : 'none';
                item.config.actions = data.config.actions;
            }
            return item;
        };
        this.calcXYPass = function (d, xSteps, ySteps) {
            var x = xSteps(d.x);
            var y = ySteps(d.y);
            return [x, y];
        }
        this.unSelectComponent = unSelectComponent;
        this.updateComponentPosition = updateComponentPosition;
        this.transformComponentPosition = transformComponentPosition;
    };

    connection_box.dispatch.on('conectionClick', function (event) {
        switch (showMode) {
            // click in design mode
            case hmi.constant.showMode.design:
                if (pendingPipe) {
                    pipe.Change(event);
                }

                break;
        }
    });

    resize_component.dispatch.on('finish_resize', function (event) {
        switch (showMode) {
            // click in design mode
            case hmi.constant.showMode.design:
                pipe.updateChangeLink(event);
                break;
        }
    });

    line_valve._options = Object.create({}, {
        // simple options, just get/set the necessary values
        showMode: {
            get: function () {
                return showMode;
            },
            set: function (_) {
                showMode = _;
            }
        },
        availableWidth: {
            get: function () {
                return availableWidth;
            },
            set: function (_) {
                availableWidth = _;
            }
        },
        availableHeight: {
            get: function () {
                return availableHeight;
            },
            set: function (_) {
                availableHeight = _;
            }
        },
        valueFormat: {
            get: function () {
                return valueFormat;
            },
            set: function (_) {
                valueFormat = _;
            }
        },
        zoomTrans: {
            get: function () {
                return zoomTrans;
            },
            set: function (_) {
                zoomTrans = _;

                var xSteps = hmi.utils.StepsComponents(availableWidth, 1.5 * defaultWidth, zoomTrans.scale);
                var ySteps = hmi.utils.StepsComponents(availableHeight, 1.5 * defaultHeight, zoomTrans.scale);
                xScale.domain(xSteps[0]).range(xSteps[1]);
                yScale.domain(ySteps[0]).range(ySteps[1]);

            }
        },
        pipe: {
            get: function () {
                return pipe;
            },
            set: function (_) {
                // _.dispatch.on('pendingPipeChange', function (d) {
                //     pendingPipe = !d.pipe ? false : true;
                // });
                pipe = _;

            }
        },
        pendingPipe: {
            get: function () {
                return pendingPipe;
            },
            set: function (_) {
                pendingPipe = !_.pipe ? false : true;
            }
        },
        action_execute: { get: function () { return action_component; } }
    });

    hmi.utils.initOptions(line_valve);

    return line_valve;
};